interface HeaderStatProps {
  label: string;
  value: string | number;
  valueClassName?: string;
}

export function HeaderStat({ label, value, valueClassName }: HeaderStatProps): JSX.Element {
  return (
    <div className="text-center">
      <div className={`text-title-md font-semibold ${valueClassName ?? ''}`.trim()}>{value}</div>
      <div className="text-xs text-text-muted">{label}</div>
    </div>
  );
}
